import useSwr from 'swr'

import { type Course } from '@mc/api'

import { pruneRelatedCourses, PrunedCourse } from 'libs/utils'

type UseCoursesByCategoryReturn = {
  coursesByCategory: PrunedCourse[] | undefined
  error: Error
  isLoading: boolean
}

export const useCoursesByCategory = (
  slug?: string | null,
): UseCoursesByCategoryReturn => {
  const { data, error, isLoading } = useSwr<Course[]>(
    `/jsonapi/v1/courses?filter[category]=${encodeURIComponent(slug || '')}`,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  )

  return {
    coursesByCategory: data && pruneRelatedCourses(data),
    error,
    isLoading,
  }
}

type UseCoursesBySlugsReturn = {
  coursesBySlugs: Course[] | undefined
  error: Error
  isLoading: boolean
}

export const useCoursesBySlugs = (
  slugs?: string[] | null,
): UseCoursesBySlugsReturn => {
  const joinedSlugs = slugs?.join(',') || ''
  const fetcher =
    slugs && slugs.length
      ? `/jsonapi/v1/courses?filter[slug]=${encodeURIComponent(joinedSlugs)}`
      : null

  const { data, error, isLoading } = useSwr<Course[]>(fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  })

  return {
    coursesBySlugs: data,
    error,
    isLoading,
  }
}
